export { default } from './Columna';
